// extracted by mini-css-extract-plugin
module.exports = {"root":"app-logo_root_2AVs2"};